module.exports = __webpack_public_path__ + "media/countdown.19909ad5.mp3";